<template>
	<div class="ml-45 mr-44 " :class="['content', { 'fade': fadeOut }]">
		<!-- {{usersshu}} -->
		<div class="userprofil1 w100" v-if="!isEditing && !fadeOut" >
			<div class="flex j-between pb-22 a-center" style="border-bottom: 1px solid #E1E1E1; box-sizing: border-box;">
				<div class="tit-24 ys-33 B-400 userProfile-righttitle montserRegular">
					<!-- Personal information -->
					{{gudingziduan.Personal.Personalinformation}}
				</div>
				<!-- <div class="userProfile-right-btn tit-17 ys-33 B-300 " @click="edit">Edit</div> -->
			</div>
			<!-- <el-divider></el-divider> -->
			<div class="userProfile-right-contrn pt-44">
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">
						<!-- User Name -->
						{{gudingziduan.Personal.UserName}}
					</div>
					<div class="tit-16 ys-33 B-300 ml-68">{{usersshu.nickname}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">
						<!-- Country/Region -->
						{{gudingziduan.Personal.Country}}
					</div>
					<div class="tit-16 ys-33 B-300 ml-68">{{usersshu.country}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">
						<!-- language -->
						{{gudingziduan.Personal.language}}
					</div>
					<div class="tit-16 ys-33 B-300 ml-68" >{{usersshu.language}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">
						<!-- Email -->
						{{gudingziduan.Personal.Email}}
					</div>
					<div class="tit-16 ys-33 B-300 ml-68" >{{usersshu.account}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">firstName</div>
					<div class="tit-16 ys-33 B-300 ml-68" >{{usersshu.firstName}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">lastName</div>
					<div class="tit-16 ys-33 B-300 ml-68" >{{usersshu.lastName}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">roleName</div>
					<div class="tit-16 ys-33 B-300 ml-68" >
					{{usersshu.roleName}}</div>
				</div>
				<div class="flex mb-30">
					<div class="tit-15 B-300" style="color: #838383;width: 115px;">loginTime</div>
					<div class="tit-16 ys-33 B-300 ml-68" >{{usersshu.loginTime}}</div>
				</div>
				
			</div>
		</div>
		<div class="userprofil1 w100" v-else-if="isEditing">
			<div class="flex j-between flex-wrap pb-22 a-center" style="border-bottom: 1px solid #E1E1E1; box-sizing: border-box;">
				<div class="tit-24 ys-33 B-400 userProfile-righttitle montserRegular">Supplementary Information</div>
				<div class="userProfile-right-btn2 tit-17 ys-33 B-300 " @click="back"><span class="iconfont icon-fanhui mr-8"></span>back</div>
			</div>
			<!-- <el-divider></el-divider> -->
			<div class="userProfile-right-contrn pt-44">
				<el-form ref="form" :model="usersshu" label-width="0px">
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">
								<!-- User Name: -->
								{{gudingziduan.Personal.UserName}}:
								</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.nickname"
									placeholder="Solarland Bayern GmbH" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">First Name:</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.firstName"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">Last Name:</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.lastName"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">
							{{gudingziduan.Personal.Email}}:
								<!-- Email: -->
							</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.account"
									placeholder="Solarland Bayern GmbH@bayern.com" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">{{gudingziduan.Personal.Country}}:</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.country"
									placeholder="Germany" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">{{gudingziduan.Personal.Organization}}:</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.organization"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012">＊</div>
							<div class="ProfileFrom-a3  tit-20 ys-33">{{gudingziduan.Personal.JobTitle}}:</div>
							<div class="ProfileFrom-a4">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.jobTitle"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012"></div>
							<div class="ProfileFrom-a3  tit-20 ys-33">{{gudingziduan.Personal.Address}}:</div>
							<div class="ProfileFrom-a4" style="width:85.4%;">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.address"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012"></div>
							<div class="ProfileFrom-a3  tit-20 ys-33">Zip Code:</div>
							<div class="ProfileFrom-a4" style="width:85.4%;">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.postal"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="flex item">
							<div class="ProfileFrom-a2 z-E60012"></div>
							<div class="ProfileFrom-a3  tit-20 ys-33">City:</div>
							<div class="ProfileFrom-a4" style="width:85.4%;">
								<el-input size="medium" class="userProfileinput" v-model="usersshu.city"
									placeholder="" placeholder-class="tit-16"
									placeholder-style="color:##A1A1A1;"></el-input>
							</div>
						</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer flex j-center mt-40 pb-30">
					<div class="Profilesave tit-18 ys-0 B-500"  @click="save">{{gudingziduan.Personal.Submit}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  data() {  
	    return {  
	      isEditing: false ,
		  fadeOut: false,
		  gudingziduan:{}
		  // usersshu:{'nickname':'Alick','country':'China','account':'Alick@168.com'}
	    };  
	  },  
	  props: {
	  	usersshu: {
	  		type: [Object,Array],
	  		default() {
				return { /* 默认对象或数组的内容 */ };
			  }
	  	},
	  },
	  watch: {
	      '$store.state.cunyuanyan': {
	        handler(newValue, oldValue) {
	          // console.log('语言已更新:', newValue);
	          this.gudingziduan=this.$store.state.cunyuanyan
	  		console.log(this.gudingziduan,'video')
	        },
	        deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	      }
	  },
	  created() {
		  this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		  this.gudingziduan=this.$store.state.cunyuanyan
	  	// console.log(this.$props.usersshu,'---------')
	  },
	  computed: {  
	    contentStyle() {  
	      return {  
	        transform: this.isEditing ? 'translateX(-100%)' : 'translateX(0)',  
	        transition: 'transform 0.5s ease'  
	      };  
	    }  
	  },  
	  methods: {  
	   edit() {
	     this.fadeOut = true;  
	     setTimeout(() => {  
	       this.isEditing = true;  
	       this.fadeOut = false;  
	     }, 300); // 与 CSS 动画时长同步  
	   },  
	   back() {  
	     this.isEditing = false;  
	   },  
	   save() {  
	     alert("Changes saved!");  
	     this.isEditing = false;  
	   }
	  }  
	}; 
</script>

<style lang="scss" scoped>
	.userprofilbox{
		flex-grow: 1;  
		display: flex;  
		// width: 100%; /* 使内容部分宽度占满容器 */  
		overflow: hidden; /* 避免溢出 */  
	}
	::v-deep .el-input__inner {
		border: none !important;
		border-radius: .05rem;
	}
	.ProfileFrom-btn1 {
		padding: .14rem .5rem;
		color: #333;
		background: #f5f5f5;
		border-radius: 23px;
		display: inline-block
	}
	.Profilesave {
		background-image: linear-gradient(4deg, rgb(255, 117, 88) 0%, rgb(230, 0, 18) 100%);
		color: #fff;
		padding: .12rem .45rem;
		border-radius: 100px;
		display: inline-block
	}
	.ProfileFrom-a2 {
		// color:#;
		height: 40px;
		line-height: 40px;
	}
	
	.ProfileFrom-a3 {
		height: 40px;
		line-height:40px;
		width: 199px;
	}
	.ProfileFrom-a4 {
		height:40px;
		width: 92%;
		border: 1px solid #e9e9e9;
		border-radius: .1rem;
		overflow: hidden;
		::v-deep .el-input {
			height:40px;
	
			.el-input__inner {
				height:100%;
				line-height: initial;
			}
		}
	}
	.content {
	  transition: transform 0.3s ease, opacity 0.3s ease;  
	}  
	.fade {
	  opacity: 0;  
	  transform: translateY(-10px); /* 向上消失效果 */  
	}  
	.userProfile-right{
		width:77%;
		min-height: 7.2rem;
		.userProfile-right-btn{
			display: inline-block;
			padding: .12rem .52rem;
			border-radius: 26px;
			border: 1px solid #e50012;
			box-sizing: border-box;
		}
		.userProfile-right-btn2{
			border: none;
			display: inline-block;
			padding: .12rem .52rem;
		}
	}
	
.userProfile-right-contrn .el-form-item {margin-bottom: .2rem;}

// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width: 767px) {
.userProfile-right-contrn .el-form .el-form-item .item {flex-wrap: wrap;}
.ProfileFrom-a4 {width: 100%;}	

}

</style>